import React from 'react';
import { connect } from 'react-redux';

const Style = props => {
    let style = null;

    if (props.configuration && props.configuration.custom && props.configuration.custom.style  && typeof props.configuration.custom.style === 'string') {
        style = props.configuration.custom.style;
    }

    if (style) {
        return (
            <style>{style}</style>
        )
    } else {
        return null;
    }
};

const mapStateToProps = state => {
    return {...state};
}

export default connect(mapStateToProps)(Style);